export default {
  description: {
    en: `
    Discover our curated collection of premium perfumes and colognes from the most <br class="onlyDesktop" />
    exclusive fragrance houses, hand-picked by our team of scent experts.
  `,
  },
}
